import * as React from 'react';
import { inject } from 'mobx-react';
import { CurrentHotelStore } from 'stores/current-hotel-store';
import { ContextStore } from 'bernie-core';
import { MesoTrigger } from 'components/meso/meso-trigger';
import { PageName } from 'constants/pages';
import { ErrorBoundary } from 'bernie-view';

interface MesoHotelLinkDirectProps {
  slot: string;
  currentHotel?: CurrentHotelStore;
  context?: ContextStore;
}

@inject('currentHotel', 'context')
export class MesoHotelLinkDirect extends React.Component<MesoHotelLinkDirectProps> {
  public render() {
    const { currentHotel, context, slot } = this.props;
    const hotelId = (currentHotel && String(currentHotel.hotelId)) || null;
    const hotel = (currentHotel && currentHotel.hotel) || null;
    const rooms = (currentHotel && currentHotel.offers && currentHotel.offers.rooms) || null;
    const cheapestRoom = (rooms && rooms.length > 0 && rooms[0]) || null;
    const prices =
      (cheapestRoom &&
        cheapestRoom.ratePlans &&
        cheapestRoom.ratePlans[0] &&
        cheapestRoom.ratePlans[0].paymentPlans &&
        cheapestRoom.ratePlans[0].paymentPlans[0] &&
        cheapestRoom.ratePlans[0].paymentPlans[0].paymentPlanStats) ||
      null;
    const adProps = {
      slot,
      hotelid: hotelId,
      cid: (hotel && hotel.hotelBrandId) || null,
      isloggedin: (context && context.user && context.user.state === 'authenticated') || false,
      showicon: false,
      issoldout: !cheapestRoom,
      cur: (context && context.currency) || null,
      ladr: (prices && prices.statsPrice) || 0
    };

    return (
      <ErrorBoundary label="meso.hotel.link.direct">
        <meso-hotel-link-direct {...adProps} />
        <MesoTrigger pageName={PageName.INFOSITE} />
      </ErrorBoundary>
    );
  }
}
